import React, { useState, useRef, useEffect, useCallback } from 'react';
import FilterIcon from '../../../assets/images/Filter.png';
import GreyFilterIcon from '../../../assets/images/Filter_grey.png';
import { useTranslation } from 'react-i18next';
import SearchInput from '../../Search';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from 'js-cookie';

import debounce from 'lodash.debounce';
import { appTheme } from '../../../helpers/utils/Utils';
import { useNavigate, Link } from 'react-router-dom';
import insightsIcon from '../../../assets/images/insight-image.png';
import insightsDisableIcon from '../../../assets/images/insights_disable_image.png';

const Tabs = (props) => {
        global.checkIconVisibleFormGlobal = true
  const { children, onFilterClick,showFilterOverlay, isEnabled, updateActiveTab, selectedTab,closeArrowIcon, SearchVal,filterEnable, handleSubmitSearch, cardType, labelDisable, activityDisable, upComingDisable , goalsDisable, handleGotitWithSearchClick,handleGotitWithSearchClickForSaving,goalsTabDisable, marginLeft=false, space , showFilterAndsearch=false ,billPayments=false , hideSearchAndFilterBtn=false , gap=false, recurring=false} = props
  const { t } = useTranslation();
  const dispatch = useDispatch();

  //debugger;

  // const defaultActiveTab = "filter";
  const defaultActiveTab = selectedTab != undefined ? selectedTab : children && children.length > 0 ? children[0].props.label : null;

  const [activeTab, setActiveTab] = useState(defaultActiveTab);
  const [isInputVisible, setIsInputVisible] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [showCloseIcon, setShowCloseIcon] = useState(false);
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  const [isTooltipVisibleForSaving, setIsTooltipVisibleForSaving] = useState(false);
  const footerStylesNoRecordsForFee = "font-hanken-grotesk text-center cursor-pointer pt-24 font-[500] md:font-[500]  lg:text-[18px] md:text-[18px]  sm:text-[12px] text-[14px] leading-[18px]  w-full";

  const [labelsShow, setLabelsShow] = useState(true);

  const showSearchOnHome = useSelector(state => state.showSearchOnHome);
  const SearchFiltervalue = useSelector(state => state.SearchFiltervalue);
  const closeIconFromStore = useSelector(state => state.closeIconFromStore);

  const containerRef = useRef(null);
  const inputRef = useRef(null);
  const placeholderText = `Search ${activeTab}`;
  const cards = useSelector(state => JSON.parse(state.userCards));
  const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
  const appThemeData = appTheme(kudzuPlusTrue)
  const navigate = useNavigate()
  const isSmiOneIsTrue = useSelector(state => state.smiOneAccountTrue);
  


  const handleClick = (e, newActiveTab) => {
    CloseIconClick()
     if(newActiveTab === 'Activity' || newActiveTab === 'Insights'){
      if(activityDisable){
        return
      }
    } else if(newActiveTab === 'Upcoming'){
      if(upComingDisable){
        setIsInputVisible(false)
        return
      }
    }
      if(newActiveTab === 'Upcoming'){
        setIsInputVisible(false)
      }
      else{
        // setIsInputVisible(true)
      }
    e.preventDefault();
    // if ((props?.cardType != t('checking') ? isEnabled : true)) {
    

   // When bill-payments tabs switch, close the search UI to avoid it staying open.
    if (billPayments) {
      setIsInputVisible(false);
    }

      setActiveTab(newActiveTab);
      updateActiveTab(newActiveTab)
      console.log("activetab-------------------", activeTab);
    // }
  };


  



  const handleSearchClick = useCallback(() => {
    
    if (cardType === 'Spending') {
      const showTooltip = { showTooltip: false };
      handleGotitWithSearchClick()
      dispatch({ type: 'SHOW_TOOLTIP', payload: showTooltip });
    } else if (cardType === 'Savings') {
      const showTooltipForSavings = { showTooltipForSavings: false };
      dispatch({ type: 'SHOW_TOOLTIP_FOR_SAVING', payload: showTooltipForSavings });
      handleGotitWithSearchClickForSaving()
    }
    setIsInputVisible(!isInputVisible);

    const tooltipCookieNameForSpending = `tooltipShown_${cards[0].CardKey}`;
    const tooltipShow = Cookies.get(tooltipCookieNameForSpending);
    const tooltipCookieNameForSaving = `tooltipShownForSavings_${cards[0].CardKey}`;
    const tooltipShowForSavings = Cookies.get(tooltipCookieNameForSaving);


    if (!tooltipShow && cardType === 'Spending') {
      setIsTooltipVisible(true);
    }
    else if (!tooltipShowForSavings && cardType === 'Savings') {
      setIsTooltipVisibleForSaving(true);
    }
    setLabelsShow(false);
  }, [cardType,cards[0].CardKey, dispatch]);


  const handleClear = () => {
    dispatch({ type: 'SEARCH_FILTER_VALUE', payload: { SearchFiltervalue: '' } });
    dispatch({ type: 'SHOW_SEARCH_ON_HOME', payload: { showSearchOnHome: false } });
    setInputValue('');
    setIsInputVisible(false);
    setLabelsShow(true);
    const showTooltip = { showTooltip: true }
    dispatch({ type: 'SHOW_TOOLTIP', payload: showTooltip });
    const spendingSessionStatus = sessionStorage.getItem("tooltipState_Spending");
    const savingSessionStatus = sessionStorage.getItem("tooltipState_Saving");
    if (spendingSessionStatus == null || savingSessionStatus == null) {
      const showTooltip = { showTooltip: true }
      dispatch({ type: 'SHOW_TOOLTIP', payload: showTooltip });
    } else {
      const showTooltip = { showTooltip: false }
      dispatch({ type: 'SHOW_TOOLTIP', payload: showTooltip });
    }
    // handleSubmitSearch('');
  };

  const handleSearchValue = useCallback(
    debounce((value) => {
      setInputValue(value);
      // alert(value);
      handleSubmitSearch(value,activeTab);
    }, 300), // 300ms debounce time
    []
  );

  const handleSearchChange = (value) => {
    global.searchValueFromGlobal = value;
    handleSearchValue(value);
  };


  const handleArrowClick = () => {
    setShowCloseIcon(true);
    // Some pages don't provide `closeArrowIcon` callback; avoid crashing.
    if (typeof closeArrowIcon === 'function') {
      closeArrowIcon(true)
    }
  }

  useEffect(()=>{
    if(!!closeIconFromStore){
    setShowCloseIcon(true);
    }
    else{
    setShowCloseIcon(false);
    }
  },[closeIconFromStore])

  useEffect(()=>{
    dispatch({ type: 'CLOSE_ICON_FROM_STORE', payload: { closeIconFromStore: false } });
  },[selectedTab])

    

  const CloseIconClick = () => {
    setInputValue('');
  }

  const hideTootipGotIt = () => {
    const tooltipCookieNameForSpending = `tooltipShown_${cards[0].CardKey}`;
    Cookies.set(tooltipCookieNameForSpending, 'true', { expires: 1825 }); 
    setIsTooltipVisible(false);
  }
  const hideTootipGotItForSaving = () => {
    const tooltipCookieNameForSaving = `tooltipShownForSavings_${cards[0].CardKey}`;
    Cookies.set(tooltipCookieNameForSaving, 'true', { expires: 1825 });
    setIsTooltipVisibleForSaving(false)
  }


  useEffect(() => {
    if (SearchFiltervalue) {
      if (!isInputVisible) { // Only update if the state has actually changed
        setIsInputVisible(showSearchOnHome);
        sessionStorage.setItem('tooltipShown', true);
        handleSearchClick();
      }
    }
  }, [SearchFiltervalue, showSearchOnHome, handleSearchClick, isInputVisible]);

  const searchFilterBlock = (
    <>
    {!recurring &&
    <>
     <SearchInput
        placeholderText={t('search_placeholder')}
        isEnabled={isEnabled}
        labelsShow={labelsShow}
        handleSearchClick={handleSearchClick}
        isInputVisible={isInputVisible}
        isTooltipVisible={isTooltipVisible}
        CloseIconClick={CloseIconClick}
        showCloseIcon={showCloseIcon}
        onInputChange={handleSearchChange}
        handleArrowClick={handleArrowClick}
        handleClear={handleClear}
        selectedTab={selectedTab}
        hideTootipGotIt={hideTootipGotIt}
        hideTootipGotItForSaving={hideTootipGotItForSaving}
        isTooltipVisibleForSaving={isTooltipVisibleForSaving}
      />
      <button
        type="button"
        onClick={() => { if (isEnabled) onFilterClick(activeTab); }}
        className={`flex justify-between ml-auto space-x-1 ${isEnabled ? ' cursor-pointer text-[var(--btn-clr-cards)]' : 'text-[var(--btn-clr-cards-tabs-disable)] cursor-not-allowed'}  lg:text-[18px] md:text-[18px] sm:text-[11px] text-[14px] font-[600] sm:font-[700]  items-center`}
        disabled={!isEnabled}
        aria-label={t('FiltersBtn', { tab: activeTab })}
      >
        <img
          src={isEnabled ? appThemeData.filterIcon : appThemeData.greyfilterIcon}
          alt={t('filter_icon_alt')}
          className={`lg:w-[14px] lg:h-[14px] md:w-[11px] md:h-[11px] w-[10px] h-[10px] mr-[6px] ${isEnabled ? '' : 'opacity-50'}`}
          aria-hidden="true"
        />
        <span className="">{t('FiltersBtn')}</span>
      </button>

    </>}
     
    </>
  );



  
  return (
    <>

    <div className={`insights flex items-center ${gap ? "md:px-0" :" md:px-16"} sm:px-[2.5rem] ${billPayments ? 'justify-start gap-6 flex-nowrap relative after:content-[""] after:absolute after:bottom-0 after:left-[2.5rem] md:after:left-16 after:h-px after:w-[86%] after:bg-[var(--btn-clr-cards-tabs-inactive)] after:opacity-30 mb-4' : ''} ${!billPayments ? `${labelsShow ? 'space-x-6' : 'sm:space-x-6'} justify-between` : ''}`}>

        <div 
          role="tablist" 
          aria-label={billPayments ? t('billPaymentsTabs') || 'Bill Payments Tabs' : cardType ? `${cardType} Account Tabs` : 'Account Tabs'}
          className="flex items-center gap-4"
        >
        {React.Children.map(children, (child) => (
 <div className={`${child.props.label === t('insight') ? 'insight-tooltip' : ''} flex items-center space-x-2 shrink-0 ${billPayments ? '' : 'gap-4'}`}>
          {!billPayments && <>
           {child.props.label !== t('ActivityTab') &&
            <>
             {isSmiOneIsTrue && <img
              src={isEnabled ? insightsIcon : insightsIcon}
              alt={t('searchIconAlt')}
              className={`lg:w-[17px] lg:h-[17px] md:w-[11px] md:h-[11px] ${isSmiOneIsTrue ? 'ml-[10px] mr-[-10px]' : 'mr-[6px]'}  ${isEnabled ? '' : 'opacity-50'}`}
            />}</>
            } 
          </>
          }

          <button
            type="button"
            key={child.props.label}
            id={`tab-${child.props.label}`}
            className={`${labelsShow ? 'block' : 'sm:block hidden'} 
    ${billPayments ? 'whitespace-nowrap' : 'md:w-[60px] sm:w-[39px]'} lg:text-[18px] md:text-[18px] sm:text-[11px] text-[14px] font-[600] sm:font-[700] py-3
        ${(activeTab === child.props.label)
               ? `cursor-pointer ${billPayments ? 'border-b-2 -mb-px' : (isSmiOneIsTrue ? '' : 'border-t-2')} border-[var(--btn-clr-cards-tabs)] text-[var(--btn-clr-cards-tabs)]`
                : 'text-[var(--btn-clr-cards-tabs-inactive)] cursor-pointer'
              }`
            }
            onClick={(e) => handleClick(e, child.props.label)}
            role="tab"
            aria-selected={activeTab === child.props.label}
            aria-controls={`tabpanel-${child.props.label}`}
            tabIndex={activeTab === child.props.label ? 0 : -1}
          >
           {child.props.label} 
             {billPayments && child.props.count !== undefined && child.props.count !== null ? ` (${child.props.count})` : ''}
          </button>
          </div>
        ))}
        </div>

        {!billPayments && <div className="flex-grow"></div>}
        {!billPayments && !hideSearchAndFilterBtn && searchFilterBlock}
        {!billPayments && hideSearchAndFilterBtn && (
          <Link
            to="/Transactions"
            state={{ accountType: cardType === t('checking') || cardType === 'Spending' ? 'spending' : 'savings' }}
            className="cursor-pointer text-[var(--btn-clr-cards)] lg:text-[18px] md:text-[18px] sm:text-[11px] text-[14px] font-[600] sm:font-[700] rounded"
          >
            {t('viewAll')}
          </Link>
        )}
      </div>

      {/* {billPayments && hideSearchAndFilterBtn  &&(
        <div className="flex justify-between items-center md:px-16 sm:px-[2.5rem] py-3">
          {searchFilterBlock}
        </div>
      )} */}


      {React.Children.map(children, (child) => {
        if (child.props.label === activeTab) {
          return (
          
            <div
              id={`tabpanel-${child.props.label}`}
              role="tabpanel"
              aria-labelledby={`tab-${child.props.label}`}
              tabIndex="0"
              className={`${ space ? "" : "md:px-16 sm:px-[2.5rem]"} ${billPayments ? "mb-36" : ""}`}
              key={child.props.label}
            >
              <table className={`w-full ${billPayments ? 'mt-[1rem]': "mt-[2rem]"}`}>
                <tbody>{child.props.children}</tbody>
              </table>
                <div
                className={`${footerStylesNoRecordsForFee} text-left ${kudzuPlusTrue ? 'text-[#ffffff]' : 'text-[rgba(38,43,58,0.7)]'}`}
              >
                {child.props.message || ""}
              </div>
            </div>
            
          );
        } else {

        }
        return null;
      })}

    </>
  );
};



const Tab = ({ label, children }) => {
  return (
    <div label={label} className="hidden">
      {children}
    </div>
  );
};
export { Tabs, Tab };